import React from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import FormElement from '../add-edit-product/FormElement';
import styles from './Styles/add-inventory-batch.scss';
import ProductExpiry from '../add-edit-product/ProductExpiry/ProductExpiry';
import { useState } from 'react';
import InventoryProductInfo from './InventoryProductInfo';
import {connect, useSelector , useDispatch } from 'react-redux';
import axios from "axios";
import useMRPInputField from '../../common/UpdateMRP/MRPInputFileld/singleMRP';
import { Regex } from '../../utills';
import { showToastMessage } from '../../actions/toastmessage';
import toastMessageActions from "jd-library/toastMessageActions";

const AddInventoryBatch = props => {
    const { token, isReadOnly } = useSelector((state) => state.session);
    const { isIPhone } = useSelector((state) => state.deviceData);

    const priceRegex = /^\d{0,10}(\.\d{0,2})?$/;
    const numberRegex = /^\d{0,8}$/;

    const dispatch = useDispatch();
    const expiry_date_flag = !props.FromMarketPlaceInv
      ? useSelector((state) => {
          return state.products.editProduct.productId != "ADD_PRODUCT"
            ? state.products.editProduct.expiry_date_flag
            : state.productSpecification.expiryFlag;
        })
      : "";
    let expiryFlag = Number(expiry_date_flag) || props.expiryFlag 
    if(props.session?.viaOmni){
      expiryFlag=props.permissions?.packagePermissionData?.isMaintainExpiry
    }
    const [data,updateData] = useState(props.addInventoryBatch?{
      ...props.addInventoryBatch,bestBeforeUnit:'months',errors:{},warnings:{}
    }:{
        'quantity': '',
        'mrp': '',
        'sellingPrice': '',
        'expiry_date': '',
        'manufacturing_date': '',
        'newConsignmentNo': '',
        'best_before': '',
        'bestBeforeUnit':'months',
        'expiryBy': 'manufacturing_date',
        errors: {},
        warnings: {}
    })

    const [showLoader, setShowLoader] = useState(false)
    const [mrpImages, setMrpImages] = useState(() => {});
    const [productFrontProof, setProductFrontProofImages] = useState(() => {});
    const [sendProductData,setSendProductData] = useState({
      mrp: data.mrp,
      uomType: 'package',
      mrp_list: props?.productData?.mrp_list || props.mrp_list,
      mrp_status: props?.productData?.mrp_status === 'EMPTY_MRP_LIST' ? 'EMPTY_MRP_LIST' : '',
      uploadImageError: mrpImages?.uploadImageError,
      uploadProductFrontImageError:productFrontProof?.uploadProductFrontImageError
    })

    const handleChange = (key,value,err,warn) => {
        let newData = {...data};
        let mrp = newData["mrp"] ? newData["mrp"] : null;
        switch (key) {
          case "quantity":
            {
              if (!numberRegex.test(value)) {
                return;
              }else if(Number(value) > 100) {
                newData.errors.quantity = 'Cannot be More than 100'
              }else {
                newData.errors.quantity = '';
              }
            }
            break;
          case "mrp":
            {
              if (!priceRegex.test(value)) {
                return;
              }
            }
            break;
          case "sellingPrice":
            {
              if (!priceRegex.test(value)) {
                return;
              }
            }
            break;
        }
        if (key == "sellingPrice") {
          if (value && Number(value) && (!mrp || Number(value) > Number(mrp))) {
            newData.errors.sellingPrice = "Higher than MRP";
          } else {
            newData.errors.sellingPrice = "";
          }
        }
        if (key == "mrp" && newData["sellingPrice"]) {
          if (Number(value) >= Number(newData["sellingPrice"])) {
            newData.errors.sellingPrice = "";
          } else {
            newData.errors.sellingPrice = "Higher than MRP";
          }
        }
        // if(value!=null)
            newData[key]=value;
        if(err!=null)
            newData['errors'][key]=err
        if(warn!=null)
            newData['warnings'][key]=warn
        updateData({...newData});
    }
    const {getMRPInput,getUpdateMRPModal,getBothCommentAndUpload} = useMRPInputField(
      !Boolean(props.productData?.mrp_list?.length === 1 && parseInt(props?.productData?.mrp_list[0],10) === 0), // this parameter to enable new MRP inventory flow
      { session: { isReadOnly } },
      sendProductData,
      isIPhone,
      styles,
      (err = null, key , { value }) => {
        handleChange(key , null);
        setTimeout(() => {
          handleChange(key, value);
        },20)
      },
      () => {},
      {},
      (key, value) => {
        setSendProductData(e=>{
          return {...e,uploadImageError:null,uploadProductFrontImageError:null}
        })
        if(key === 'isUnknownMrpValue'){
          setMrpImages({
            isUnknownMrpValue: value,
            mrp_images: mrpImages?.mrp_images || ''
          })
          setProductFrontProofImages({...productFrontProof,isUnknownMrpValue: value})
        } else if(key === 'mrp_images'){
          setMrpImages({ ...mrpImages , mrp_images: value})
          // setSendProductData(e=>{
          //   return {...e,uploadImageError:null}
          // })
        }
        else if(key=="mrp_front_img"){
          setProductFrontProofImages({...productFrontProof,proof:value})
          // setSendProductData(e=>{
          //   return {...e,uploadProductFrontImageError:null}
          // })
        }
      },
    )

    const updateErrors = err => {
      updateData({
        ...data,
        errors: err
      })
    }

    const validateData = () => {
        let errMsg = "";
        // let newErrors={...errors};
        let newData = {...data};
        if (!data.quantity ||
          Number(data.quantity) == 0
        ) {
          if (typeof data.quantity === 'undefined' || String(data?.quantity || '').length === 0) {
            newData.errors.quantity = "Please Enter Quantity";
            errMsg = "Please Enter Quantity";
          }
          if(Number(data?.quantity) === 0){
            newData.errors.quantity = "Cannot be 0";
            errMsg = "Quantity cannot be 0";
          }
          if (!data.mrp) {
            newData.errors.mrp = "Please Enter MRP";
          }
          if (!data.sellingPrice) {
            newData.errors.sellingPrice = "Please Enter Price";
          }
        }else if(Number(data.quantity) > 100) {
          newData.errors.quantity = 'Cannot be More than 100';
          errMsg = 'Qty Cannot be More than 100'
        } else if (!data.mrp || Number(data.mrp) === 0) {
          if (!data.mrp) {
            newData.errors.mrp = "Please Enter Price";
            errMsg = errMsg ? '' : "Please Enter MRP Price";
          }
          if (String(data.mrp).length > 0 && Number(data.mrp) === 0) {
            newData.errors.mrp = "Cannot be 0";
            errMsg = "MRP Price Value cannot be 0";
          }
          if (!data.sellingPrice) {
            newData.errors.sellingPrice = 'Please Enter Price';
          }
        } else if (!data.sellingPrice) {
          newData.errors.sellingPrice = "Please Enter Price";
          errMsg = "Please Enter Price";
        }
        if (
          data.sellingPrice &&
          Number(data.sellingPrice) == 0
        ) {
          newData.errors.sellingPrice = "Cannot be 0";
          errMsg = errMsg ? errMsg : "Selling Price Value Cannot be 0";
        }

        if (String(data.mrp).length > 0 && Number(data.mrp) === 0) {
          newData.errors.mrp = "Cannot be 0";
          errMsg = newData.errors.quantity ? errMsg : "MRP Price Value cannot be 0";
        }

        if (Number(data.mrp) === 1) {
          newData.errors.mrp = "Invalid Value";
          errMsg = "MRP Value is Invalid";
        }
        if (
          Number(data.sellingPrice) == 1 ||
          Number(data.sellingPrice) < 0
        ) {
          newData.errors.sellingPrice = "Invalid Value";
          errMsg = errMsg ? errMsg : "Selling Price Value is Invalid";
        }
        if (newData.errors.sellingPrice == "Higher than MRP") {
          errMsg = errMsg ? errMsg : "Selling Price Cannot be Higher than MRP";
        }

        if(mrpImages?.isUnknownMrpValue && !mrpImages?.mrp_images){
          setMrpImages({...mrpImages, uploadImageError: ''});
          errMsg = '';
          setSendProductData(e=>{
            return {...e,uploadImageError:''}
          })
        } else{
          setSendProductData(e=>{
            return {...e,uploadImageError:null}
          })
        }

        if(productFrontProof?.isUnknownMrpValue && !productFrontProof?.proof){
          setMrpImages({...mrpImages, uploadProductFrontImageError: ''});
          errMsg = '';
          setSendProductData(e=>{
            return {...e,uploadProductFrontImageError:''}
          })
        } else{
          setSendProductData(e=>{
            return {...e,uploadProductFrontImageError:null}
          })
        }
        if(expiryFlag){
            const getDateObj = (dateString) => {
              let dateStr = typeof dateString === 'string' ? dateString : dateString.value;
              if(dateStr)
              {
                  var dateParts = dateStr.split('/');
                  // month is 0-based, that's why we need dataParts[1] - 1
                  var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                  return(dateObj);
                }
            }
            const currentDate = new Date();

            if(data.newConsignment?.length < 4) {
            errMsg = errMsg ? errMsg : "Batch Lot Number must be at least 4 characters long";
            newData.errors.newConsignment = "Batch Lot Number must be at least 4 characters long";
            }
            if(data.expiryBy == 'expiry_date') {
              if(data.expiry_date) {
                let value = getDateObj(data.expiry_date);
                if(value) {
                  currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
                  //Ignore time param while comparing two dates.
                }
                if(currentDate > value) {
                  errMsg = errMsg ? errMsg : "You have Entered Expired Date";
                  newData.errors.expiry_date = "You have Entered Expired Date";
                }
              }
            } else {
              let checkExpirtyCalc = true;

             if(data.best_before == '0') {
                  errMsg = errMsg ? errMsg : 'Please Enter Valid Value';
                  newData.errors.best_before = 'Please Enter Valid Value';
                  checkExpirtyCalc = false;
              }
              let value = getDateObj(data.manufacturing_date);
              if (checkExpirtyCalc && value) {
                currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds());
              var expDateByBestBefore = new Date(currentDate);
              var bestBeforeInDays = Number(data.best_before);
              var bestBeforeUnit = data.bestBeforeUnit || 'months';
              if(bestBeforeUnit == 'months'){
                bestBeforeInDays = bestBeforeInDays * 30;
              }else if(bestBeforeUnit == 'years'){
                  bestBeforeInDays = bestBeforeInDays * 365;
              }
              expDateByBestBefore.setTime( value.getTime() + bestBeforeInDays * 86400000 );
                if(currentDate < value){
                  errMsg = errMsg ? errMsg : 'You have Entered Future Date as Manufacturing Date';
                  newData.errors.manufacturing_date = 'You have Entered Future Date as Manufacturing Date'
                } else if(currentDate > expDateByBestBefore) {
                  errMsg = errMsg ? errMsg : 'Product has Already Expired.';
                  newData.errors.manufacturing_date = 'Product has Already Expired.';
                }
              }
            }
        }
        updateData({...newData});
        return errMsg;
    };
    function formatDateToSend(date) {
        if (date && date.toString().indexOf("/") > -1) {
            var strDate = date.split("/");
            return [strDate[2], strDate[1], strDate[0]].join('-');
        } else {
            return null;
        }
      }

    const onSaveData= ()=>{
        const isError = validateData();
        console.log(mrpImages,'mrpImages',"\t\t","productFrontProof",productFrontProof);
        let expiryDate = "";
        let manufacturingDate = "";
        const expiryBy = data.expiryBy;
        const finalBestBeforeVal = data.best_before&& data.bestBeforeUnit? data.best_before+ "-" + data.bestBeforeUnit: "";
        if (expiryBy == "expiry_date") {
          expiryDate = formatDateToSend(data.expiry_date);
          data.best_before = "";
        } else if (
          expiryBy == "manufacturing_date" &&
          data.manufacturing_date
        ) {
          manufacturingDate = formatDateToSend(data.manufacturing_date);
        }
        let consignmentObj = {
            mrp: Number(data.mrp),
            sellingPrice: Number(data.sellingPrice),
            costPrice: Number(data.costPrice),
            quantity: Number(data.quantity),
            barcode: "",
            best_before: finalBestBeforeVal || "",
            manufacturing_date: manufacturingDate || null,
            newConsignmentNo: data.newConsignment || "",
            consignmentNo: '',
            expiry_date: expiryDate || null,
          };
        if(mrpImages?.isUnknownMrpValue && mrpImages?.mrp_images){
          consignmentObj.mrp_images = mrpImages.mrp_images;
        }
        if(productFrontProof?.isUnknownMrpValue && productFrontProof?.proof){
          consignmentObj.mrp_front_img = productFrontProof.proof;
        }
        if(!isError){
          if(props.FromMarketPlaceInv || props.itemInfo.productId !=='ADD_PRODUCT'){
            setShowLoader(true)
            const params = {
                token: token,
                productId: props.itemInfo.productId,
                action: 'updateInventorybatch'
              };
              if(props.session?.viaOmni){
                params.viaOmni = 1
              }
              axios.post('/marketplace/static/php/web/b2bWebsite.php', consignmentObj,
                {
                  params,
                  headers: {
                    "Content-Type": "application/json"
                  },
                }
              )
                .then((res) => {
                    setTimeout(() => {
                        setShowLoader(false)
                        props.handleInventorySave()
                    }, 500)
                });
          }
          else{
            props.handleInventorySave(consignmentObj)
          }
        }else if(isError.length){
          props.showToastMessage({
            showToastMessage: true,
            message: isError,
            type: 'error',
            duration: 5000
        });
        }
    }

    const formFields = [
        {
            holderClass: styles['mrp-sp-qty-holder'],
            formElements: [
                {
                    label: 'In Stock Qty.',
                    key: 'quantity',
                    ignoreParentClass: true,
                    input: {
                        value: data.quantity || '',
                        type: "tel",
                        onFocus: () => handleChange('quantity',null,''),
                        onChange: e => {
                          if(!Regex.priceRegex.test(e.target.value)){
                            return;
                          }
                          handleChange('quantity',e.target.value)
                        }

                    }
                },
                {
                    label: 'MRP',
                    key: 'mrp',
                    ignoreParentClass: true,
                    input: {
                        type: isIPhone ? "text" : "tel",
                        value: data.mrp || '',
                        onFocus: () => handleChange('mrp',null,''),
                        onChange: e => {
                          if(!Regex.priceRegex.test(e.target.value)){
                            return;
                          }
                          handleChange('mrp',e.target.value)
                        }
                    },
                    hide: props.hideMrp,
                    holderClass:`mrp-input-wrap`
                },
                {
                  ...getMRPInput(!props.hideMrp)
                },
                {
                    label: 'Selling Price',
                    key: 'sellingPrice',
                    ignoreParentClass: true,
                    input: {
                        value: data.sellingPrice || '',
                        type: isIPhone ? "text" : "tel",
                        onFocus: () => handleChange('sellingPrice',null,''),
                        onChange: e => {
                          if(!Regex.priceRegex.test(e.target.value)){
                            return;
                          }
                          handleChange('sellingPrice',e.target.value)
                        }
                    }
                }
            ]
        }
    ]
    if(expiryFlag){
        formFields.push({
            label : 'Batch / Lot Number',
            key : 'newConsignment',
            input: {
                value: data.newConsignment,
                onFocus: () => handleChange('newConsignment',null,''),
                onChange: e => handleChange('newConsignment',e.target.value)
            },
            holderClass: styles["batch-lot-num"],
        })
    }


    return (
        <SliderWrapper
            header={{
                heading: 'Add New Inventory',
                rightIcons: []
            }}
            footer={{
                className: "inventory-slider-footer",
                btnProps: [
                  {
                    children: "Save",
                    onClick: (e) => onSaveData(e),
                    showLoader :showLoader
                  },
                ],
            }}
            onHidden ={props.onHidden}
        >
            <div className={styles['add-batch-container']}>
                <InventoryProductInfo
                    ImageUrl={props.itemInfo.imageUrl}
                    productName={props.itemInfo.productName}
                />
                <FormElement
                    formElements={formFields}
                    errors={data.errors}
                />
                {getBothCommentAndUpload(sendProductData)}
                {expiryFlag ?
                    <ProductExpiry
                        errors={data.errors || {}}
                        setItemErrors={updateErrors}
                        itemInfo={{
                            manufacturing_date: data['manufacturing_date'],
                            expiry_date: data['expiry_date'],
                            expiryBy: data['expiryBy'],
                            best_before: data['best_before'],
                            bestBeforeUnit: data['bestBeforeUnit']
                        }}
                        warnings={data.warnings || {}}
                        // errors={productData.errors}
                        updateInfoAndErrors={handleChange}
                        fromAddInventory ={true}
                    />:null
                }
            </div>
            {getUpdateMRPModal()}
        </SliderWrapper>
    )
};

// export default AddInventoryBatch;

const mapStateToProps=(state)=>{
  return {
    permissions: state.permissions,
    session:state.session,
  }
}

export default connect(mapStateToProps, {
  showToastMessage: toastMessageActions.showMessage,

})(AddInventoryBatch);
